import { useToast } from '@app/core/notifications';
import { pushTo } from '@app/core/routing';
import { adminAuditPaths } from '@app/modules/audit/routing/admin-audit-paths';
import {
  auditReportsListReportDefinitionQueryKey,
  useAuditReportsCreateReportDefinition,
} from '@mi-front/api-v2';
import { Add } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { FormattedMessage, useIntl } from 'react-intl';

interface Props {
  reportType: string;
}

export function CreateButton({ reportType }: Props) {
  const { $t } = useIntl();
  const { notifyError } = useToast();
  const queryClient = useQueryClient();

  const createMutation = useAuditReportsCreateReportDefinition({
    mutation: {
      onSuccess: async (createdDefinition) => {
        await queryClient.invalidateQueries({
          queryKey: auditReportsListReportDefinitionQueryKey({
            reportType,
          }),
        });
        pushTo(adminAuditPaths.reportDefinitionById(createdDefinition.id));
      },
      onError: (error) => {
        notifyError(
          $t({
            id: 'audit.reportDefinitions.createError',
            defaultMessage: 'Error al crear la plantilla',
          }),
        );
        console.error(error);
      },
    },
  });

  const handleCreate = () => {
    createMutation.mutate({ reportType });
  };

  return (
    <Button
      onClick={handleCreate}
      loading={createMutation.isPending}
      variant="contained"
      color="primary"
      size="small"
      startIcon={<Add />}
    >
      <FormattedMessage
        id="audit.reportDefinitions.newTemplateButton"
        defaultMessage="Nueva plantilla"
      />
    </Button>
  );
}
